export default "__VITE_ASSET__esIkbuGL__"